import React, { useState, useEffect, useRef } from 'react';
import { Link, Redirect } from 'react-router-dom'
import axios from 'axios';
import swal from 'sweetalert';
import 'react-dropzone-uploader/dist/styles.css'
import Select, { components } from 'react-select';
import moment from 'moment';

import uuid from 'react-uuid';
import { Modal, Tabs, Tab } from 'react-bootstrap';
import MUIDataTable from "mui-datatables";
import { Drawer, Button, Space } from 'antd';
import SetColor from './SetColor.js';

import { setCookie, getCookie } from '../common_component/cookie.js';
import Organization_modal from '../common_component/organization_modal.js';
import Timer_modal from '../common_component/timer_modal.js';

function AccountHead(props) {
    const timer_interval_ref = useRef();
    const [clockTimerModalShow, setClockTimerModalShow] = useState(false);
    let [state_org, setstate_org] = useState(2);
    let [organization_name, setOrganization_name] = useState("");
    const [OrganizationModalShow, setOrganizationModalShow] = useState(false);

    const [user, setUser] = useState({});
    const [timer, setTimer] = useState(0);
    const [clock_timer, setClockTimer] = useState(0);
    const [userTheme, setUserTheme] = useState((localStorage.getItem("kt_metronic_theme_mode_menu") == "system") ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : localStorage.getItem("kt_metronic_theme_mode_menu"))
    const [state, setState] = useState(2);
    const [responsive, setResponsive] = useState("vertical");
    const [tableBodyHeight, setTableBodyHeight] = useState("400px");
    const [tableBodyMaxHeight, setTableBodyMaxHeight] = useState("");

    //const [termsList, setTermsList] = useState([])
    let [redirect_to_login, setRedirect_to_login] = useState(2);
    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false)

    const [addAccHeadModalShow, setAddAccHeadModalShow] = useState(false)
    const [editAccHeadModalShow, setEditAccHeadModalShow] = useState(false)

    const [navtype, setnavtype] = useState("Overview");
    const [Dealer_name, setDealer_name] = useState("");
    const [Bank_details, setBank_details] = useState(null);
    const [Bank_history_details, setBank_history_details] = useState([]);
    const [open, setOpen] = useState(false);
    const [StatusModalShow, setStatusModalShow] = useState(false);

    let [Migration_date, setMigration_date] = useState(moment().format("yyyy-MM-DD"));
    let [timezone_change,set_timezone_change] = useState("+00:00");

    const [organization_id, setOrganization_id] = useState("");
    let [organization_list, setorganization_list] = useState([]);

    const [branchList, setBranchlist] = useState([]);
    const [currencyList, setCurrencyList] = useState([]);

    const [visibility, setvisibility] = useState(0);
    const [redirect, setredirect] = useState(0);
    const [read, setread] = useState(2);
    const [write, setwrite] = useState(2);

    const [newHead, setNewHead] = useState({account_type: "bank",account_name: "", account_code: "",currency: "", branch:"",ifsc:"",bank_name:"",account_number:"",description: "" })
    const [categoryList, setCategoryList] = useState([])
    const [bankList, setbankList] = useState([])
    const [Credit_amt, setCredit_amt] = useState(0);
    const [Category_id, setCategory_id] = useState(0);
    const [Account_id, setAccount_id] = useState(0);
    const [Debit_amt, setDebit_amt] = useState(0);
    const [Description, setDescription] = useState("");
    
    const [Uq_ac, setUq_ac] = useState("");
    const [tempAccountHeadList, setTempAccountHeadList] = useState([])
    const [accountheadList, setAccountHeadList] = useState([])
    const [User_role, setUser_role] = useState(null)

    const [editHead, SetEditHead] = useState({ name: "", code: "", uq_ac: "", sub: 0, parent: "", description: "" })

    const [submitButton, SetSubmitButton] = useState(false)
    const [status, setstatus] = useState("");
    const [bank_id, setbank_id] = useState("");

    var page_name = "account-head";
    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    let dropdownStyleDark = {
        option: (provided, state) => ({
            ...provided,
            color: '#dddddf',
            backgroundColor: state.isSelected ? provided.backgroundColor : state.isFocused ? '#5f5f8d' : provided.backgroundColor,
        }),
        control: (provided, state) => ({
            ...provided,
            backgroundColor: "#2b2b40",
            borderColor: "#4c4c71"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            color: "#dddddf",
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: "#dddddf",
        }),
        menu: (provided, state) => ({
            ...provided,
            backgroundColor: "#2b2b40",
        })
    }

    useEffect(() => {
        let id = setInterval(() => {
            setUserTheme((localStorage.getItem("kt_metronic_theme_mode_menu") == "system") ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : localStorage.getItem("kt_metronic_theme_mode_menu"))
        }, 10)

        return () => {
            clearInterval(id)
        }
    }, [])

    useEffect(() => {
        if (getCookie("access_token") != "") {
            if (getCookie("organization_id") != "") {
                setOrganization_id(getCookie("organization_id"));
            }
            else {
                var object = {};
                object.page_name = page_name;
                var headers = {
                    headers: {
                        "Content-Type": "application/json",
                        "token": getCookie("access_token"),
                        "Accept": "*/*"
                    }
                }

                axios.post(`${process.env.REACT_APP_SERVER_URL}/show-organization`, object, headers).then((res) => {
                    if (res.data.length == 1) {
                        setCookie('organization_id', res.data[0].organization_id, 1, true);
                        setOrganization_id(res.data[0].organization_id)
                    }
                    else {
                        setstate_org(1);
                        setorganization_list(res.data);
                        setOrganizationModalShow(true);
                    }
                })
            }
        }
        else {
            setRedirect_to_login(1);
        }
    }, [])

    useEffect(() => {
        setCookie("lastpage", window.location.href, 1, false)
        const validateJWT = () => {

            if (getCookie("access_token") != "") {
                var object = {};
                object.token = getCookie("access_token");

                var headers = {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "*/*"
                    }
                }
                axios.post(`${process.env.REACT_APP_SERVER_URL}/get-user`, object, headers).then((res) => {
                    if (res.data.operation == "success") {
                        var user_object = {};
                        user_object.email = res.data.email;
                        user_object.name = res.data.name;
                        user_object.img = res.data.img;
                        setUser(user_object)
                    }
                    else {
                        swal("Session Expired!", "Please login to continue using.", "warning").then((value) => {
                            window.location.href = "/login"
                        });
                    }
                })
                    .catch(function (error) {
                        swal("Session Expired!", "Please login to continue using.", "warning").then((value) => {
                            window.location.href = "/login"
                        });
                    });
                object.organization_id = organization_id;
                axios.post(`${process.env.REACT_APP_SERVER_URL}/audience-info`, object, headers).then((res) => {
                    //console.log(res.data)
                    if (res.data.operation == "success") {
                        var token = res.data.audience_license;

                        if (res.data.organization_flag == 0) {
                            setstate_org(3);
                            setOrganization_name(res.data.organization_name);
                            setOrganizationModalShow(true);
                        }
                        else {
                            var path = window.location.pathname;
                            path = path.replace(/\/$/, "");
                            path = decodeURIComponent(path);
                            var original_url = path.split("/")[1]
                            let index = 0;
                            let temp = -1;
                            for (let i = 0; i < res.data.user_access.access.length; i++) {
                                if (temp == 1) break;
                                let component = res.data.user_access.access[i].inside_components;
                                for (let j = 0; j < component.length; j++) {
                                    if (component[j].hasOwnProperty(original_url)) {
                                        index = i;
                                        if (res.data.user_access.access[index].inside_components[j][original_url] == 1 && res.data.user_access.access[index].visibility == 1) {
                                            temp = 1;
                                            setvisibility(1);
                                            setread(res.data.user_access.access[index].inside_components[j]["read"])
                                            setwrite(res.data.user_access.access[index].inside_components[j]["write"]);
                                            break;
                                        }
                                        else {
                                            setredirect(1);
                                        }
                                    }
                                    else if (component[j].hasOwnProperty("key")) {
                                        let sub_inside_components = component[j].inside_components
                                        for (let k = 0; k < sub_inside_components.length; k++) {
                                            if (sub_inside_components[k].hasOwnProperty(original_url)) {
                                                index = i
                                                if (sub_inside_components[k][original_url] == 1 && res.data.user_access.access[index].visibility == 1 && component[j].visibility == 1) {
                                                    temp = 1;
                                                    setvisibility(1);
                                                    setread(sub_inside_components[k]["read"])
                                                    setwrite(sub_inside_components[k]["write"])
                                                    // setwrite(0)
                                                    break;

                                                }
                                                else {
                                                    setredirect(1);
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        temp = 2;
                                    }
                                }

                            }
                            if (temp == 2) {
                                setredirect(1);
                            }
                        }

                        if (!token.includes("ufhdsupw29fher") || !token.includes("pdbwu27dh6schs") || !token.includes("0dh27agiqbcrwi")) {
                            setCookie('access_token', res.data.audience_license, 1, true)
                            setTimer(process.env.REACT_APP_JWT_EXPIRY);
                            //setClockTimer(process.env.REACT_APP_JWT_EXPIRY);
                        }
                        else {
                            setTimer(res.data.audience_count);
                        }
                    }
                    else {
                        setRedirect_to_login(1);
                    }
                })
                    .catch(function (error) {
                        console.log(error);
                        setRedirect_to_login(1);
                    });
            }
            else {
                setRedirect_to_login(1);
            }
        }
        organization_id != "" && validateJWT();
    }, [organization_id])

    useEffect(() => {
        timer_interval_ref.current = setInterval(() => {
            setTimer((timer) => {
                if (timer > 0 && timer < process.env.REACT_APP_JWT_EXPIRY_NOTICE) {
                    if (!clockTimerModalShow) {
                        setClockTimer(process.env.REACT_APP_JWT_EXPIRY_NOTICE)
                        setClockTimerModalShow(true)
                    }
                }
                return timer - 1
            })
        }, 1000);

        return () => { clearInterval(timer_interval_ref) };
    }, []);

    async function getBankList() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-bank-list`, { method: 'POST', body: JSON.stringify({ "organization_id": organization_id,"flag": true,"email": user.email, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        //console.log(body.data)

        if (body.operation === "success") {
            let temp_dropdown_paid = [];
            let temp_dropdown = [];
            setbankList(body.data);
        }
    }

    async function getTimezoneInformation() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-organization-timezone-information`, { method: 'POST', body: JSON.stringify({ "email": user.email,"page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") 
        {
            if(body.data.length>0)
            {
                if(body.data[0].timezone_value != "" && body.data[0].timezone_value != null)
                {
                    let timezone_change = body.data[0].timezone_value;
                    set_timezone_change(timezone_change);
                    setMigration_date(moment().zone(timezone_change).format('YYYY-MM-DD'));
                }
            }
        }
        else {
            throw "timezone api error"
        }
    }

    async function getBranchDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-branches`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)

        if (body.operation == "success") {
            setBranchlist(body.data);
            let temp = body.data.filter(option => option.default_branch == "yes")
            if (temp.length > 0) {
                //console.log(temp[0]);
                //setSelectedBranch({ label: temp[0].branch_name, value: temp[0].branch_id });
                //setSelectedPlaceOfSupply({ label: temp[0].branch_address_state, value: temp[0].branch_address_state });
                //console.log({ label: temp[0].branch_address_state, value: temp[0].branch_address_state });
                //getDefaultTransactionSeries(temp[0].branch_id);
            }
        }
        else {
            throw "branch list api error"
        }
    }
    async function getcurrencydetails() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/currency-datatable`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.length != 0) {
            setCurrencyList(body)
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getBankList();
            let p2 = getBranchDetails();
            let p3 = getcurrencydetails();
            let p4 = getTimezoneInformation();
            Promise.all([p1,p2,p3,p4])
                .then(() => {
                    setState(1);
                    console.log("all apis done")
                })
                .catch((err) => {
                    setState(0)
                })
        }

    }, [user, visibility, read, write])

    const editSetup = (head) => {
        SetEditHead(head)
        setEditAccHeadModalShow(true);
    }

    const onClose = () => {
        setOpen(false);
    }

    const newHeadSubmit = () => {
        // //Name check
        // if (newHead.uq_ac == "") {
        //     swal("Warning!", "Select a Category", "warning");
        //     return
        // }
        // var nexp = /^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9 \/\\&|@#()\\[\]_.,:"']*)?$/;
        // //Name check
        // if (newHead.name == "") {
        //     swal("Warning!", "Head must have name", "warning");
        //     return
        // }
        // if (!newHead.name.match(nexp)) {
        //     swal("Warning!", "Head name cannot contain a number or symbols", "warning");
        //     return
        // }
        // let flag = false
        // accountheadList.map((head) => {
        //     // if (head.wid != object.wid) {
        //     if (head.name.trim().toLowerCase() == newHead.name.toLowerCase()) {
        //         flag = true
        //     }
        //     // }
        // })
        // if (flag) {
        //     swal("Warning!", "Name already exists", "warning");
        //     return
        // }

        // let flag2 = false
        // categoryList.map((category) => {
        //     // if (category.wid != object.wid) {
        //     if (category.name.trim().toLowerCase() == newHead.name.toLowerCase()) {
        //         flag2 = true

        //     }
        //     // }
        // })
        // if (flag2) {
        //     swal("Warning!", "Name Cannot be same of any Category", "warning");
        //     return
        // }

        // //Code check
        // if (newHead.code == "") {
        //     swal("Warning!", "Head must have a code", "warning");
        //     return
        // }
        // let flag3 = false
        // accountheadList.map((head) => {
        //     // if (head.wid != object.wid) {
        //     if (head.code.trim().toLowerCase() == newHead.code.toLowerCase()) {
        //         flag3 = true
        //     }
        //     // }
        // })
        // if (flag3) {
        //     swal("Warning!", "Code name already take", "warning");
        //     return
        // }
        // //Sub Parent check
        // if (newHead.sub && !String(newHead.parent).trim().length) {
        //     swal("Warning!", "Sub-Head must have a parent", "warning");
        //     return
        // }
        // if (!newHead.sub && String(newHead.parent).trim().length) {
        //     swal("Warning!", "non Sub-Head should have a parent", "warning");
        //     return
        // }
        let amount=0;
        if(Credit_amt!=0)
        {
            amount=-Credit_amt;
        }
        else if(Debit_amt!=0)
        {
            amount=Debit_amt;
        }
        let arr=newHead;
        //console.log()
        //console.log(arr.branch.map(o =>o.value));
        if(arr.branch.length>0)
        {
            arr.branch=arr.branch.map(o =>o.value)
        }
        let object = {bank_details:arr,Credit_amt:Credit_amt,Debit_amt:Debit_amt,amount:amount,Uq_ac:Uq_ac,page_name: page_name, organization_id: organization_id };

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        SetSubmitButton(true)
        axios.post(`${process.env.REACT_APP_SERVER_URL}/save-bank-details`, object, headers).then((res) => {
            SetSubmitButton(false)
            if (res.data.operation === "success") {
                swal("Great!", res.data.message, "success").then((value) => {
                    // window.location.reload();
                    //getaccountheads()
                    //setAddAccHeadModalShow(false)
                });
            }
            else {
                swal("Oops!", res.data.message.substring(0, 30), "error");
            }
        })
        .catch(function (error) {
            console.log(error)
        });
    }

    const EditOpeningBalance = (obj) => {
        //console.log(obj);
        setCategory_id(obj.bank_details.acc_cid);
        setAccount_id(obj.bank_details.acc_hid);
        if(obj.headArray.length>0)
        {
            setDescription(obj.headArray[0].description);
            setCredit_amt(obj.headArray[0].withdrawl_amnt);
            setDebit_amt(obj.headArray[0].deposit_amnt);
        
            if(obj.headArray[0].migration_date!=undefined)
            {
                setMigration_date(moment(obj.headArray[0].migration_date).zone(timezone_change).format('YYYY-MM-DD'));
            }
            else
            {
                setMigration_date(moment().zone(timezone_change).format('YYYY-MM-DD'));
            }
        }
        setStatusModalShow(true); 
    }

    const RecordOpeningBalance = () => {
        let amount=0;
        if(Credit_amt!=0)
        {
            amount=-Credit_amt;
        }
        else if(Debit_amt!=0)
        {
            amount=Debit_amt;
        }
        let data=[{Credit_amt:Credit_amt,Debit_amt:Debit_amt,amount:amount,hid:Account_id,cid:Category_id,"Description":Description,"date":Migration_date}]
        let object = {data:data,page_name: page_name, organization_id: organization_id };

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        SetSubmitButton(true)
        axios.post(`${process.env.REACT_APP_SERVER_URL}/record-bank-opening-balance`, object, headers).then((res) => {
            SetSubmitButton(false)
            if (res.data.operation === "success") {
                swal("Great!", res.data.message, "success").then((value) => {
                    // window.location.reload();
                    //getaccountheads()
                    //setAddAccHeadModalShow(false)
                });
            }
            else {
                swal("Oops!", res.data.message.substring(0, 30), "error");
            }
        })
        .catch(function (error) {
            console.log(error)
        });
    }

    return (
        <>
            {
                (redirect == 1 || (read == 0 && write == 0)) ?
                    <>
                        <Redirect to={{
                            pathname: "/unauthorized",
                        }}
                        />
                    </> :
                    null
            }
            {
                redirect_to_login == 0 ? null : (redirect_to_login == 1 ? <>
                    <Redirect to={{ pathname: "/login" }} />
                </> : null)
            }

            <div className="d-flex flex-column flex-column-fluid">
                <div className="app-toolbar py-3 py-lg-6" id="kt_app_toolbar">
                    <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Banking Overview

                            <small className="text-muted fs-7 fw-bold my-1 ms-1"></small>
                        </h1>
                        <div className="d-flex align-items-center gap-2 gap-lg-3">
                            <button className='btn btn-success' onClick={(e) => { setAddAccHeadModalShow(true) }}>
                                <i className="las la-plus"></i>
                                Add Bank
                            </button>
                            {/* <button className="btn btn-success rounded" onClick={() => { setupDefault() }}>
                                <span className="indicator-label">set Default</span>
                            </button> */}
                        </div>
                    </div>
                </div>
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    <div id="kt_app_content_container" className="app-container container-xxl">
                        {
                            state == 1 ?
                                <>
                                <div className="row g-6 g-xl-9">
                                    {bankList.length > 0 ?
                                    <>
                                    {bankList.map((obj, index) => {
                                        return (
                                            <>
                                                <div className="col-lg-6">
                                                    <div className="card card-flush h-lg-100">
                                                        <div className="card-header mt-6">
                                                            <div className="card-title flex-column">
                                                                <h3 className="fw-bolder mb-1">{obj.bank_details.account_name}</h3>
                                                                {obj.bank_details.log_status == "Active" ? <span className="badge badge-light-success me-auto rounded">Active</span> : (obj.bank_details.log_status == "Stopped" ? <span className="badge badge-light-danger me-auto rounded">Stopped</span> : <span className="badge badge-light-danger me-auto rounded">Deactivated</span>)}
                                                            </div>
                                                            <div className="card-toolbar">
                                                                <div className="dropdown">
                                                                    {
                                                                        (write) ?
                                                                    <>
                                                                    <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                        <i className="fas fa-bars px-0"></i>
                                                                    </button>
                                                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                            <li><a onClick={(e) => {EditOpeningBalance(obj); }}  className="dropdown-item">Opening Balance</a></li>
                                                                        </ul>
                                                                    </>        
                                                                    :
                                                                    null
                                                                    }
                                                                </div>
                                                            </div>	
                                                        </div>
                                                        <div className="d-flex flex-wrap">
                                                            <div className="card-body p-9">
                                                                <div className="fs-6 d-flex justify-content-between mb-4">
                                                                    <div className="fw-bold">Account number</div>
                                                                    <div>
                                                                        {obj.bank_details.legal_name}</div>
                                                                </div>
                                                                <div className="separator separator-dashed"></div>
                                                                <div className="fs-6 d-flex justify-content-between my-4">
                                                                    <div className="fw-bold">Bank Name</div>
                                                                    <div>
                                                                    {obj.bank_details.bank_name}</div>
                                                                </div>
                                                                <div className="separator separator-dashed"></div>
                                                                <div className="fs-6 d-flex justify-content-between my-4">
                                                                    <div className="fw-bold">Branch Name</div>
                                                                    <div>
                                                                    {obj.bank_details.bank_name}</div>
                                                                </div>
                                                                <div className="separator separator-dashed"></div>
                                                                <div className="fs-6 d-flex justify-content-between mt-4">
                                                                    <div className="fw-bold">Add Date</div>
                                                                    
                                                                    <div>{moment(obj.bank_details.log_date_time).format('ll')}</div>
                                                                </div><br />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        );
                                    })}
                                    </>
                                    :
                                    <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                        <div className="d-flex flex-stack flex-grow-1">
                                            <div className="fw-bold">
                                                <h4 className="text-gray-800 fw-bolder">No Bank Available.</h4>
                                                <div className="fs-6 text-gray-600"> </div>
                                            </div>
                                        </div>
                                    </div>	
                                    }
                                </div>
                                </>
                                :
                                state == 2 ?
                                    <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                    :
                                    state == 3 ?
                                        <>
                                            <div className="flex-lg-row-fluid me-lg-15">
                                                <div className="card card-flush pt-3 mb-5 mb-lg-10">
                                                    <div className="card-body pt-0">
                                                        <div className="text-gray-500 fw-bold fs-5 mb-5"></div>
                                                        <div className="d-flex align-items-center p-3 mb-2"></div>

                                                        <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                                            <div className="d-flex flex-stack flex-grow-1">
                                                                <div className="fw-bold">
                                                                    <h4 className="text-gray-800 fw-bolder">No Banking Overview Available</h4>
                                                                    <div className="fs-6 text-gray-600"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className="flex-lg-row-fluid me-lg-15">
                                                <div className="card card-flush pt-3 mb-5 mb-lg-10">
                                                    <div className="card-body pt-0">
                                                        <div className="text-gray-500 fw-bold fs-5 mb-5"></div>
                                                        <div className="d-flex align-items-center p-3 mb-2"></div>

                                                        <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                                            <div className="d-flex flex-stack flex-grow-1">
                                                                <div className="fw-bold">
                                                                    <h4 className="text-gray-800 fw-bolder">Please Refresh this page</h4>
                                                                    <div className="fs-6 text-gray-600"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                        }
                    </div>
                </div>

            </div>
            <Modal show={addAccHeadModalShow} onHide={() => { setAddAccHeadModalShow(false) }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>New Bank Account</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setAddAccHeadModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-4 my-auto">
                                <label className="required fs-5 mb-2">Account Category</label>
                            </div>
                            {/* <div className='col-9 my-auto'> */}
                                {/* <div className="col-9 row row-cols-1 row-cols-md-3 row-cols-lg-1 row-cols-xl-3 g-9"> */}
                                    <div className="col-4 me-2">
                                        <label className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6 ${newHead.account_type==="bank" && "active"}`} data-kt-button="true">
                                            <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                                                <input className="form-check-input" type="radio" name="discount_option"  onChange={(e) => {
                                                    setNewHead({account_type: "bank",account_name: "", account_code: "",currency: "", branch:"",ifsc:"",bank_name:"",Debit_amt:0,Credit_amt:0,account_number:"",description: "" })}} checked={newHead.account_type==="bank"}/>
                                            </span>
                                            <span className="ms-5">
                                                <span className="fs-4 fw-bold text-gray-800 d-block">Bank</span>
                                            </span>
                                        </label>
                                    </div>
                                    <div className="col-4">
                                        <label className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6 ${newHead.account_type==="credit_card" && "active"}`} data-kt-button="true">
                                            <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                                                <input className="form-check-input" type="radio" name="discount_option" value="3" onChange={(e) => {
                                                    setNewHead({account_type: "credit_card",account_name: "", account_code: "",currency: "",bank_name:"",Debit_amt:0,Credit_amt:0,description: "" })}} checked={newHead.account_type==="credit_card"}/>
                                            </span> 
                                            <span className="ms-5">
                                                <span className="fs-4 fw-bold text-gray-800 d-block">Credit Card</span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            {/* </div> */}
                        {/* </div> */}
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Account Name</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="text" className="form-control form-control-solid"
                                    // value={primaryContact.firstName}
                                    onChange={(e) => { setNewHead({ ...newHead, account_name: e.target.value }) }}
                                    placeholder='Account Name'
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">Account Code</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="text" className="form-control form-control-solid"
                                    // value={primaryContact.firstName}
                                    onChange={(e) => { setNewHead({ ...newHead, account_code: e.target.value }) }}
                                    placeholder='Account Code'
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Currency</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <Select
                                    styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                    options={currencyList.map(x => { return { label: x.currency_code, value: x.currency_id } })}
                                    onChange={(val) => { setNewHead({ ...newHead, currency:val})  }}
                                    //value={selectedCurrency}
                                />
                            </div>
                        </div>
                        {newHead.account_type==="bank" &&
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">Account Number</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="text" className="form-control form-control-solid"
                                    // value={primaryContact.firstName}
                                    onChange={(e) => { setNewHead({ ...newHead, account_number: e.target.value }) }}
                                    placeholder='Account Number'
                                />
                            </div>
                        </div>}
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">Bank Name</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="text" className="form-control form-control-solid"
                                    // value={primaryContact.firstName}
                                    onChange={(e) => { setNewHead({ ...newHead, bank_name: e.target.value }) }}
                                    placeholder='Bank Name'
                                />
                            </div>
                        </div>
                        {newHead.account_type==="bank" &&
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">IFSC</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="text" className="form-control form-control-solid"
                                    // value={primaryContact.firstName}
                                    onChange={(e) => { setNewHead({ ...newHead, ifsc: e.target.value }) }}
                                    placeholder='IFSC Number'
                                />
                            </div>
                        </div>}
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">Opening Balance</label>
                            </div>
                            <div className='col-4 me-3'>
                                <input type="number" className="form-control form-control-solid"
                                    value={Credit_amt.toString()}
                                    onChange={(e) => { setCredit_amt(e.target.value == "" ? 0 : parseFloat(e.target.value)) }}
                                    onBlur={(e) => {setDebit_amt(0)}}
                                    placeholder='Credit'
                                />
                                <span className="text-muted fs-6">Credit Amount</span>
                            </div>
                            {/* <div className='col-2 my-auto'></div> */}
                            <div className='col-4'>
                                <input type="number" className="form-control form-control-solid"
                                    value={Debit_amt.toString()}
                                    onChange={(e) => { setDebit_amt(e.target.value == "" ? 0 : parseFloat(e.target.value))}}
                                    onBlur={(e) => {setCredit_amt(0)}}
                                    placeholder='Debit'
                                />
                                <span className="text-muted fs-6">Debit Amount</span>
                            </div>
                        </div>
                        {newHead.account_type==="bank" &&
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">Assosiate Branch</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <Select
                                    isMulti
                                    styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                    options={branchList.map((x) => { return { label: x.branch_name, value: x.branch_id } })}
                                    onChange={(val) => {
                                        setNewHead({ ...newHead, branch: val})
                                        //setSelectedBranch(val);
                                        //setSelectedTransactionSeries(null)
                                    }}
                                    //value={selectedBranch}
                                    placeholder="Select Branch"
                                />
                            </div>
                        </div>}
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">Description</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <textarea type="text" className="form-control form-control-solid"
                                    // value={primaryContact.firstName}
                                    onChange={(e) => { setNewHead({ ...newHead, description: e.target.value }) }}
                                    placeholder='Description'
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded me-auto" onClick={() => { setAddAccHeadModalShow(false) }}>Close</button>
                    {
                        // write == 1 &&
                        <button className="btn btn-success rounded" data-kt-indicator={submitButton ? "on" : "off"} disabled={submitButton} onClick={() => { newHeadSubmit() }}>
                            <span className="indicator-label">Save and Continue</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    }
                </Modal.Footer>
            </Modal>

            <Modal show={StatusModalShow} onHide={()=>{setStatusModalShow()}} size="md" centered>
				<Modal.Header>
					<Modal.Title>Record Opening Balance</Modal.Title>
					<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={()=>{setStatusModalShow(false)}}>
						<span className="svg-icon svg-icon-1">
							<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
								<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
									<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
									<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
								</g>
							</svg>
						</span>
					</div>
				</Modal.Header>
				<Modal.Body>
                    <div className='container'>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Date:</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="date" name="Migration_date" className="form-control" id="Migration_date" placeholder="Sales Start Date" value={Migration_date}
                                    onChange={(e) => {
                                        setMigration_date(moment(e.target.value).zone(timezone_change).format('YYYY-MM-DD'));
                                        const temp=[...categoryList];
                                        temp.map((obj) => {
                                            obj.headArray.map((obj1) => {
                                                obj1.Date=moment(e.target.value).zone(timezone_change).format('YYYY-MM-DD');
                                            })
                                        })
                                        setCategoryList(temp);    
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">Opening Balance</label>
                            </div>
                            <div className='col-4 me-3'>
                                <input type="number" className="form-control form-control-solid"
                                    value={Credit_amt.toString()}
                                    onChange={(e) => { setCredit_amt(e.target.value == "" ? 0 : parseFloat(e.target.value)) }}
                                    onBlur={(e) => {setDebit_amt(0)}}
                                    placeholder='Credit'
                                />
                                <span className="text-muted fs-6">Credit Amount</span>
                            </div>
                            {/* <div className='col-2 my-auto'></div> */}
                            <div className='col-4'>
                                <input type="number" className="form-control form-control-solid"
                                    value={Debit_amt.toString()}
                                    onChange={(e) => { setDebit_amt(e.target.value == "" ? 0 : parseFloat(e.target.value))}}
                                    onBlur={(e) => {setCredit_amt(0)}}
                                    placeholder='Debit'
                                />
                                <span className="text-muted fs-6">Debit Amount</span>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">Description</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <textarea type="text" className="form-control form-control-solid"
                                    value={Description}
                                    onChange={(e) => {setDescription(e.target.value)}}
                                    placeholder='Description'
                                />
                            </div>
                        </div>
					</div>
				</Modal.Body>
				<Modal.Footer> 
					<button type="button" onClick={(e) => {setStatusModalShow(false)}} className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
					{write==1 &&<form >
						<button type="button" onClick={(e) => { RecordOpeningBalance(e) }} className="btn btn-primary"  data-kt-indicator={mainSubmitButtonState?"on":"off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Record</span>
						<span className="indicator-progress">Please wait...
							<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
					</form>}
				</Modal.Footer>
			</Modal>

        <Drawer title={Dealer_name} width={window.innerWidth > 1200 ? 800 : 'auto'} bodyStyle={{ padding: "1.5rem" }} onClose={onClose} open={open} closeIcon={<a onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="38px" height="38px"><path fill="#f44336" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"/><path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z"/><path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z"/></svg>
            </a>}
                extra={
                    <Space>
                         {/* <Button onClick={onClose} type="primary">Close</Button> */}

                    </Space>
                }

            >
                <div className="card">
                    <div className="d-flex w-100 overflow-auto">
                        <ul className="nav nav-stretch nav-line-tabs fw-bold fs-6 p-0 p-lg-10 flex-nowrap flex-grow-1">
                            <li className="nav-item mx-lg-1">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Overview" && "active"}`} onClick={(e) => { setnavtype("Overview"); }}>Overview</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "History" && "active"}`} onClick={(e) => { setnavtype("History"); }}>History</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="card">
                    {navtype === "Overview" ?
                        <>
                            <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                <div className="card-title m-0">
                                    <h3 className="fw-bold m-0">Overview</h3>
                                </div>
                                {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                            </div>
                            {/* {Bank_details != null &&
                                <div className="card-body p-9">
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Expense ID</label>
                                        <div className="col-lg-8">
                                            <span className="fw-bold fs-6 text-gray-800">{Bank_details.transaction_number}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Payment Date</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{moment(Bank_details.payment_date).format("ll")}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Branch</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{Bank_details.branch_name}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Payment For</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="badge badge-light-primary">{Bank_details.Payment_for}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">User</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{Bank_details.payment_user_name}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Status
                                        </label>
                                        <div className="col-lg-8 d-flex align-items-center">
                                            {Bank_details.log_status==="PENDING_APPROVAL" ?
                                                <span className="badge badge-light-warning">Pending</span>
                                                :
                                                Bank_details.log_status==="DRAFT" ?
                                                <span className="badge badge-secondary">Draft</span>
                                                :
                                                Bank_details.log_status==="DRAFT" ?
                                                <span className="badge badge-secondary">Draft</span>
                                                :
                                                Bank_details.log_status==="cancelled" ?
                                                <span className="badge badge-danger">Cancelled</span>
                                                :
                                                <span className="badge badge-success">{Bank_details.log_status}</span>
                                            }  
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Paid Through Account</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{Bank_details.paid_through_account!=null &&`${Bank_details.paid_through_account.label}`}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Currency</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{`${Bank_details.currency.currency_code}`}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Reference</label>
                                        <div className="col-lg-8">
                                            <span className="fw-semibold fs-6 text-gray-800">{Bank_details.reference}</span>
                                        </div>
                                    </div>  
                                </div>
                            } */}
                        </>
                        
                            :
                            navtype === "History" &&
                            <>
                            <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                <div className="card-title m-0">
                                History
                                </div>
                            </div>
                            {/* {Bank_details != undefined &&
                                <div className="card-body p-9">
                                    {Bank_history_details.length>0 && Bank_history_details.map((obj, index) => {
                                        return (
                                            <>
                                            <div className="m-0">
                                                <div className="d-flex align-items-sm-center mb-5">
                                                    <div className="d-flex align-items-center flex-row-fluid flex-wrap">                    
                                                        <div className="flex-grow-1 me-2">
                                                            {obj.operation === "insert" ? <span className="badge badge-lg badge-secondary fw-bold my-2">Created</span>:obj.operation === "cancelled" ? <span className="badge badge-lg badge-danger fw-bold my-2">Cancelled</span>:obj.operation === "voucher_creation" ?<><span className="badge badge-lg badge-success fw-bold my-2">Voucher Created</span><a href={`/dealer-master-voucher-summary/${obj.master_voucher_id}`} className="text-primary fw-bold me-1"> #{obj.master_voucher_name}</a></>:<span className="badge badge-lg badge-primary fw-bold my-2">Updated</span>}
                                                        </div>                     
                                                    </div>               
                                                </div>
                                                <div className="timeline">                                 
                                                    <div className="timeline-item align-items-center mb-7">
                                                        <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                        <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                                            <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                                            <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                                            </svg>
                                                        </span>
                                                        <div className="timeline-content m-0">
                                                            <span className="fs-6 text-gray-400 fw-semibold d-block">Date</span>
                                                            <span className="fs-6 fw-bold text-gray-800">{moment(obj.log_date_time).format("lll")} </span>   
                                                        </div>                                 
                                                    </div>
                                                    <div className="timeline-item align-items-center">
                                                        <div className="timeline-line w-40px"></div>
                                                        <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                            <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                            <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                                            </svg>
                                                        </span>
                                                        <div className="timeline-content m-0">
                                                            <span className="fs-6 text-gray-400 fw-semibold d-block">User</span>
                                                            <span className="fs-6 fw-bold text-gray-800">{obj.user_id}</span>
                                                        </div>                                
                                                    </div>                                        
                                                </div>
                                            </div>
                                            {Bank_history_details.length>1 &&
                                                <div className="separator separator-dashed my-6"></div>
                                            }
                                            </>
                                        )
                                    })}
                                </div>
                            } */}
                        </>
                    }
                </div>
            </Drawer>


            <Organization_modal OrganizationModalShow={OrganizationModalShow} setOrganizationModalShow1={setOrganizationModalShow} organization_name={organization_name} organization_list={organization_list} organization_id={organization_id} state_org={state_org} mainSubmitButtonState={mainSubmitButtonState} setMainSubmitButtonState={setMainSubmitButtonState} />
            <Timer_modal clockTimerModalShow={clockTimerModalShow} setClockTimerModalShow1={setClockTimerModalShow} clock_timer={clock_timer} organization_id={organization_id} setTimer={setTimer} mainSubmitButtonState={mainSubmitButtonState} setMainSubmitButtonState={setMainSubmitButtonState} />

        </>
    );
}
export default AccountHead;